<template>
  <div id="app">
    <div class="container">
      <VueSignaturePad
        v-if="this.tipoAssinatura == 'manual'"
        height="300px"
        :customStyle="{ border: '#707070 1px solid', borderRadius: '8px' }"
        :options="{ dotSize: 5, minWidth: 5, maxWidth: 5 }"
        ref="signaturePad"
      />
      <span
        v-show="teste && this.tipoAssinatura == 'manual'"
        class="text-brand-5 text-weight-bold teste"
        >ASSINE AQUI</span
      >
    </div>
    <div
      v-show="this.tipoAssinatura == 'manual'"
      class="row col-12 justify-between q-mt-md"
    >
      <div>
        <q-btn
          @click="apagar()"
          label="Excluir Assinatura"
          color="negative"
          icon="delete"
          dense
          no-caps
          class="btn"
          outline
        />
        <q-btn
          @click="undo()"
          label="Limpar Assinatura"
          color="brand-5"
          icon="clear_all"
          outline
          dense
          no-caps
          class="btn q-ml-md"
        />
      </div>

      <div class="row container-btn-confirmar justify-end">
        <q-btn
          label="Confirmar Assinatura"
          color="positive"
          dense
          no-caps
          @click="teste()"
          icon="check_circle_outline"
          class="btn"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update", "assinar", "remover"],
  props: ["restart", "go", "tipoAssinatura"],
  name: "MySignaturePad",

  methods: {
    undo() {
      this.$refs.signaturePad.clearSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);

      this.$emit("update", data);
    },
    teste() {
      this.$emit("assinar");
    },
    apagar() {
      this.$emit("remover");
    },
  },
  watch: {
    restart() {
      this.undo();
    },
    go() {
      this.save();
    },
    tipoAssinatura() {
      console.log(this.tipoAssinatura);
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid #707070;
  background-color: white;
  cursor: crosshair;
  border-radius: 10px;
}

.buttonsCanvas {
  margin-top: 100px;
}

.save {
  margin-left: 10px;
}
.container {
  position: relative;
}
.teste {
  position: absolute;
  top: 110px;
  font-size: 50px;
  left: 190px;
  opacity: 0.3;
  z-index: -1;
}
@media only screen and (max-width: 635px) {
  .teste {
    position: absolute;
    top: 110px;
    font-size: 35px;
    left: 80px;
    opacity: 0.3;
    z-index: -1;
  }
  .btn {
    font-size: 11px;
  }
  .container-btn-confirmar {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
